import { render, staticRenderFns } from "./blocking-settings.vue?vue&type=template&id=64b9f56e&scoped=true&lang=pug&"
import script from "./blocking-settings.vue?vue&type=script&lang=js&"
export * from "./blocking-settings.vue?vue&type=script&lang=js&"
import style0 from "./blocking-settings.vue?vue&type=style&index=0&id=64b9f56e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b9f56e",
  null
  
)

export default component.exports